import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ISalesGroupPromiseLookupService } from "../ISalesGroupPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SalesGroupReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.SalesGroupImpl>
  implements ISalesGroupPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.SalesGroupImpl, "SalesGroupImpl");
  }

  getSalesGroup(id: CubiqTS.Long): Promise<CubiqTS.SalesGroupImpl> {
    let request = new UiArguments("getSalesGroup");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
